import React, { useState } from 'react';
import { Button, FormControl, Grid, Snackbar, Typography } from '@mui/material';
import ApiService from '../../../services/ApiService';
import DeleteIcon from '@mui/icons-material/Delete';

const FileUpload = ({
  onFileUploaded,
  defaultFile = null,
  onFileDeleted,
  disabled = false,
  customApi = null,
  fileExtension = ['.pdf'],
  fileFormat = ['application/pdf'],
}) => {
  const [selectedFile, setSelectedFile] = useState(defaultFile);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [url, setUrl] = useState(defaultFile?.path);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    const allowedFileTypes = [...fileFormat];
    const isValidFileType = allowedFileTypes.includes(file.type);
    const isFileSizeValid = file.size <= 20 * 1024 * 1024;

    if (!isValidFileType) {
      console.log('Invalid file type');
      setSnackbarMessage('Upload Failed: Invalid file type');
      setSnackbarOpen(true);
      setSelectedFile(null);
    } else if (!isFileSizeValid) {
      console.log('File size exceeds 20MB');
      setSnackbarMessage('Upload Failed: File size exceeds 20MB');
      setSnackbarOpen(true);
      setSelectedFile(null);
    } else {
      handleUpload(file);
    }
  };

  const handleDelete = (event) => {
    setSelectedFile(null);
    onFileDeleted();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleUpload = async (file) => {
    if (file) {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('file', file);

      try {
        if (customApi !== null) {
          const response = await customApi('ACT', formData, setUploadProgress);
          onFileUploaded(response.data.payload);
          return;
        }

        const response = await ApiService.postUploadDocument(
          'ACT',
          formData,
          setUploadProgress
        );

        setSnackbarMessage('File uploaded successfully');
        setSnackbarOpen(true);
        onFileUploaded(response.data.payload[0]);
        setUrl(response.data.payload[0].url);
      } catch (error) {
        console.error('Error uploading file:', error);
        setSnackbarMessage('Error uploading file');
        setSnackbarOpen(true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const parentStyle = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    height: '56px',
  };

  return (
    <Grid item xs={12} marginBottom={3} container sx={parentStyle}>
      <Grid item height={'56px'}>
        <FormControl>
          <label
            htmlFor="file-upload"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Button
              variant="contained"
              color={selectedFile ? 'primary' : 'primary'}
              component="span"
              sx={{ height: '56px' }}
              disabled={disabled}
            >
              Choose File
            </Button>

            <input
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept={fileExtension}
              disabled={disabled}
            />
          </label>
        </FormControl>
      </Grid>
      {!isLoading && (
        <Grid
          item
          sx={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}
        >
          {selectedFile?.name && (
            <Typography sx={{ display: 'flex', alignItems: 'center' }}>
              {selectedFile ? (
                <>
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    onClick={async (e) => await ApiService.viewFile(url, e)}
                  >
                    {selectedFile.name}
                  </a>
                  {!disabled && (
                    <DeleteIcon
                      onClick={handleDelete}
                      sx={{
                        color: '#1976D2',
                        cursor: 'pointer',
                        marginLeft: 1,
                      }}
                    />
                  )}
                </>
              ) : (
                'Attachment'
              )}
            </Typography>
          )}

          {!selectedFile?.name && (
            <Typography
              sx={{
                color: 'red',
                marginLeft: '20px',
                maxWidth: '300px',
              }}
            >
              <small>
                * Format file upload yang diterima ({fileExtension.join(', ')})
                (Maximum 20 Mb)
              </small>
            </Typography>
          )}
        </Grid>
      )}
      {isLoading && (
        <Grid
          item
          sx={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}
        >
          <Typography>Uploading... Progress: {uploadProgress}%</Typography>
        </Grid>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      />
    </Grid>
  );
};

export default FileUpload;
